import { css } from '@/styled-system/css';

export const comboboxInputGroupStyle = css.raw({
  'display': 'inline-flex',
  'alignItems': 'center',
  'columnGap': 'ChipGroup.gap.horz',
  'rowGap': 'ChipGroup.gap.vert.tighter',
  'flexGrow': 1,
  'flexWrap': 'wrap',
  'minHeight': 'Combobox.InputGroup.height.min',

  '& > [data-c11n-component="InputChip"]': {
    flexShrink: 0,
  },
});
